(() => {
  const init = root => {
    if (root.dataset.renaoFriendReady) return;
    root.dataset.renaoFriendReady = 'true';
    root.querySelector('[data-renao-collage-crop]')?.classList.add('renao-friend-crop');
    const preview = root.querySelector('[data-renao-collage-preview]');
    const fields = [...root.querySelectorAll('[data-renao-friend-field]')];
    const defaults = { 'Birinci İsim': 'EDA', 'İkinci İsim': 'ECRİN', 'Yıl': '2026' };
    const sync = () => fields.forEach(field => {
      const key = field.dataset.renaoFriendField;
      const target = preview?.querySelector(`[data-renao-friend-preview="${key}"]`);
      if (!target) return;
      const cleaned = (globalThis.RenaoCustomerTextSanitizer?.stripEmoji(field.value) ?? field.value).normalize('NFC');
      if (cleaned !== field.value) field.value = cleaned;
      let value = (field.value.trim() || defaults[key]).toLocaleUpperCase('tr-TR');
      if (key === 'İkinci İsim') value = '&' + value.replace(/^&\s*/, '');
      target.textContent = value;
      const size = key === 'Yıl' ? 21.9282 : 40.1311;
      target.style.fontSize = `${size}px`;
      const length = target.getComputedTextLength();
      const available = key === 'Yıl' ? 96 : 260;
      if (length > available) target.style.fontSize = `${size * available / length}px`;
      field.setCustomValidity('');
    });
    root.renaoSyncFriendFields = sync;
    root.renaoValidateFriendFields = () => {
      sync();
      for (const field of fields) {
        const value = field.value.trim();
        const year = field.dataset.renaoFriendField === 'Yıl';
        const valid = year ? /^[0-9]{4}$/.test(value) && Number(value)>0 : Boolean(value.replace(/[&\s]/g,'')) && Array.from(value).length<=16;
        field.setCustomValidity(valid ? '' : year ? 'Lütfen dört haneli bir yıl yazın.' : 'Lütfen en fazla 16 karakterlik bir isim yazın.');
        if (!valid) { field.reportValidity(); field.focus(); return false; }
      }
      return true;
    };
    fields.forEach(field => field.addEventListener('input', sync));
    root.addEventListener('renao:arkadas:restore', event => {
      for (const field of fields) {
        const value = event.detail?.[field.dataset.renaoFriendField];
        if (value !== undefined) field.value = String(value);
      }
      sync();
    });
    root.renaoFriendFontReady = fields.length ? document.fonts.load('40px "Renao Yan Yana"').then(sync) : Promise.resolve();
    new ResizeObserver(sync).observe(root);
    sync();
  };
  const scan = scope => scope.querySelectorAll('[data-renao-collage-personalizer][data-renao-source-product-handle="bizim-olayimiz"], [data-renao-collage-personalizer][data-renao-source-product-handle="yan-yana-magazin"], [data-renao-collage-personalizer][data-renao-source-product-handle="zarif-bizim-olayimiz"], [data-renao-collage-personalizer][data-renao-source-product-handle="zarif-yan-yana-magazin"]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
})();
